/**
 * Carousel - 轮播图组件
 * 支持触摸滑动和自动播放
 */

import React, { useState, useEffect, useRef } from 'react';
import { Left, Right } from '@icon-park/react';
import './Carousel.css';

function Carousel({ 
  images = [], 
  autoPlay = false, 
  interval = 3000,
  showControls = true,
  showIndicators = true,
  badge = null
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const timerRef = useRef(null);

  // 自动播放
  useEffect(() => {
    if (autoPlay && images.length > 1) {
      timerRef.current = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
      }, interval);
      
      return () => clearInterval(timerRef.current);
    }
  }, [autoPlay, interval, images.length]);

  // 上一张
  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  // 下一张
  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  // 跳转到指定索引
  const handleIndicatorClick = (index) => {
    setCurrentIndex(index);
  };

  // 触摸事件
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      // 向左滑动
      handleNext();
    }
    
    if (touchStart - touchEnd < -50) {
      // 向右滑动
      handlePrev();
    }
  };

  if (!images || images.length === 0) {
    return (
      <div className="carousel-container">
        <div className="carousel-empty">
          <p>暂无图片</p>
        </div>
      </div>
    );
  }

  return (
    <div className="carousel-container">
      {/* 徽章标签 */}
      {badge && (
        <div className="carousel-badge">
          <span className="badge-arrow-left"></span>
          <span className="badge-text">{badge}</span>
          <span className="badge-arrow-right"></span>
        </div>
      )}

      {/* 轮播主体 */}
      <div 
        className="carousel-track"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div 
          className="carousel-slides"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {images.map((image, index) => (
            <div key={index} className="carousel-slide">
              <img 
                src={typeof image === 'string' ? image : image.src} 
                alt={`Slide ${index + 1}`}
                className="carousel-image"
              />
            </div>
          ))}
        </div>
      </div>

      {/* 控制按钮 */}
      {showControls && images.length > 1 && (
        <>
          <button className="carousel-control carousel-prev" onClick={handlePrev}>
            <Left theme="outline" size={20} strokeWidth={3} />
          </button>
          <button className="carousel-control carousel-next" onClick={handleNext}>
            <Right theme="outline" size={20} strokeWidth={3} />
          </button>
        </>
      )}

      {/* 指示器 */}
      {showIndicators && images.length > 1 && (
        <div className="carousel-indicators">
          {images.map((_, index) => (
            <button
              key={index}
              className={`carousel-indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => handleIndicatorClick(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default Carousel;
